import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CustomHttp, ConfigServerService } from '../../../core';
import { Integracao } from '../integracao';
import { IntegracaoFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class IntegracaoEcommerceHttpService  {
    resource = 'integracao';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa todas as integrações do tipo e-commerce */
    search(): Observable<Integracao[]> {
        const filter = new IntegracaoFilter()
                            .withPlataformaTipoEcommerce();
        return this.customHttp.get<Integracao[]>(this.pathApi, {params: filter.createParams(null)});
    }

    /** Pesquisa todas as integrações do tipo e-commerce ativas */
    searchAtivas(): Observable<Integracao[]> {
        const filter = new IntegracaoFilter()
                            .withPlataformaTipoEcommerce()
                            .withSituacaoAtiva();
        return this.customHttp.get<Integracao[]>(this.pathApi, {params: filter.createParams(null)});
    }
}
